module.exports = __webpack_public_path__ + "static/media/user-pin.b91aa8c2.svg";